/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Adminnav_Users1Inputs */

const zh_adminnav_users1 = /** @type {(inputs: Adminnav_Users1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`用户管理`)
};

const en_adminnav_users1 = /** @type {(inputs: Adminnav_Users1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`User Management`)
};

const es_adminnav_users1 = /** @type {(inputs: Adminnav_Users1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestión de usuarios`)
};

/**
* | output |
* | --- |
* | "User Management" |
*
* @param {Adminnav_Users1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const adminnav_users1 = /** @type {((inputs?: Adminnav_Users1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Adminnav_Users1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_adminnav_users1(inputs)
	if (locale === "en") return en_adminnav_users1(inputs)
	return es_adminnav_users1(inputs)
});
export { adminnav_users1 as "adminNav_users" }